import { requests, requireData } from './creatorApiAgent';
import type { TQuotaBalance } from '../models/QuotaModels';

/**
 * The balance endpoint, under the backend's `Quota` controller. Request and envelope plumbing lives
 * in `creatorApiAgent`.
 *
 * Knows nothing about the store or React. A read that did not end in a balance rejects, whatever the
 * reason: there is no number to show for it, and the indicator shows nothing rather than a wrong one.
 */
const Quota = {
  /**
   * The balance of the paying owner: the signed-in owner's, and also staff's own while they work as
   * someone else, since staff are checked and charged on their own credits. The backend makes first contact and
   * renews before answering, so it is the current quota period's.
   */
  getBalance: (): Promise<TQuotaBalance> => requests.postEnvelope<TQuotaBalance>('/Quota/GetBalance').then(requireData),
};

const balanceAgent = {
  Quota,
};

export default balanceAgent;
